import nextDynamic from 'next/dynamic';
import { Navigate } from 'react-router-dom';
import { PACKS_COLLECTION_LIVE } from '@/config/features';

const Content = nextDynamic(() => import('./marketplace-content'), { ssr: false });

export default function Page() {
  // Card-economy surface — not live yet. See PACKS_COLLECTION_LIVE.
  if (!PACKS_COLLECTION_LIVE) return <Navigate to="/" replace />;
  return <Content />;
}
